export default __webpack_public_path__ + "83f4aa924a10a01028b7560c7c7aad14.png";